import { render, staticRenderFns } from "./Illustration.vue?vue&type=template&id=fad41c96&"
import script from "./Illustration.vue?vue&type=script&lang=js&"
export * from "./Illustration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fad41c96')) {
      api.createRecord('fad41c96', component.options)
    } else {
      api.reload('fad41c96', component.options)
    }
    module.hot.accept("./Illustration.vue?vue&type=template&id=fad41c96&", function () {
      api.rerender('fad41c96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Pages/Authentication/SignUp/Illustration.vue"
export default component.exports